import React, { useState, useRef, useEffect } from 'react';
import MessageInput from '../Components/MessageInput';
import aiAvatar from '../Assets/kumar-avatar.png';
import userAvatar from '../Assets/User-avatar.png';
import ChatBubble from '../Components/Chatbubble';
import TypingDots from '../Components/TypingDots';

// ← only use the env URL in production,
//     use a relative path in development so CRA proxy works
const API_BASE =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_URL
    : '';

const CareerVideos = () => {
  const [chatLog, setChatLog] = useState([
    {
      sender: 'ai',
      avatar: aiAvatar,
      name: 'Kumar',
      message: `Hey there! 👋 What career are you curious about?
Type it below and I’ll pull up the best YouTube videos to help you explore it! 🎥`,
    },
  ]);
  const [videos, setVideos] = useState([]);
  const [isThinking, setIsThinking] = useState(false);

  // ── ADD THIS for auto-scroll ───────────────────────────
  const containerRef = useRef(null);
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [chatLog, videos, isThinking]);
  // ───────────────────────────────────────────────────────

  const fetchYouTubeVideos = async (careerQuery) => {
    try {
      setIsThinking(true);
      setVideos([]);

      setChatLog((prev) => [
        ...prev,
        {
          sender: 'ai',
          avatar: aiAvatar,
          name: 'Kumar',
          message: `Awesome choice! Let me pull up some top videos about **${careerQuery}**... 🎬`,
        },
      ]);

      // ── ADD DEBUG LOG ───────────────────────────────────
      const url = `${API_BASE}/api/career-videos?career=${encodeURIComponent(careerQuery)}`;
      console.log('CareerVideos fetching ➔', url);
      const response = await fetch(url);
      console.log('CareerVideos response status ➔', response.status);
      // ────────────────────────────────────────────────────

      const data = await response.json();

      if (!data.videos || data.videos.length === 0) {
        setChatLog((prev) => [
          ...prev,
          {
            sender: 'ai',
            avatar: aiAvatar,
            name: 'Kumar',
            message: `Hmm, I couldn’t find videos for **${careerQuery}** right now. Maybe try a related field or rephrase a bit? 🤔`,
          },
        ]);
        return;
      }

      setVideos(data.videos);

      setChatLog((prev) => [
        ...prev,
        {
          sender: 'ai',
          avatar: aiAvatar,
          name: 'Kumar',
          message: `Here are some great videos to explore **${careerQuery}**! 📺 Let me know if you want more or a new topic.`,
        },
      ]);
    } catch (error) {
      console.error('Error fetching from backend:', error);
      setChatLog((prev) => [
        ...prev,
        {
          sender: 'ai',
          avatar: aiAvatar,
          name: 'Kumar',
          message: `Oops! 😢 I couldn’t fetch the videos. Check your server or internet and try again.`,
        },
      ]);
    } finally {
      setIsThinking(false);
    }
  };

  const handleUserInput = (text) => {
    const cleanText = text.trim();
    if (!cleanText) return;

    setChatLog((prev) => [
      ...prev,
      { sender: 'user', avatar: userAvatar, name: 'You', message: cleanText },
    ]);
    fetchYouTubeVideos(cleanText);
  };

  return (
    <div
      ref={containerRef}                              // ← attach ref here
      className="bg-white/90 backdrop-blur-lg rounded-[24px] shadow-md p-6 flex flex-col h-[86vh] w-full max-w-[950px] mx-auto overflow-hidden"
    >
      <div className="flex flex-col gap-6 overflow-y-auto flex-grow pr-2">
        {chatLog.map((msg, idx) => (
          <ChatBubble
            key={idx}
            sender={msg.sender}
            avatar={msg.avatar}
            name={msg.name}
            message={msg.message}
          />
        ))}

        {isThinking && (
          <ChatBubble sender="ai" avatar={aiAvatar} name="Kumar" message={<TypingDots />} />
        )}

        {videos.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-3 gap-y-5">
            {videos.map((video, idx) => (
              <div
                key={idx}
                className="flex flex-col justify-between bg-white shadow-sm border border-[#ddd] rounded-xl p-3 min-h-[300px]"
              >
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="rounded-lg w-full h-[140px] object-cover"
                />
                <div className="text-sm font-bold text-[#281D1B] font-publicsans">
                  {video.title}
                </div>
                <div className="text-xs text-[#555] font-publicsans italic">
                  {video.channel}
                </div>
                <a
                  href={`https://www.youtube.com/watch?v=${video.videoId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#FF5733] text-white text-[12px] font-bold font-syne py-2 rounded-md mt-3 text-center hover:bg-[#e24e2f] transition"
                >
                  Start to Learn
                </a>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="mt-4">
        <MessageInput onSend={handleUserInput} />
      </div>
    </div>
  );
};

export default CareerVideos;
